import { StoreIdCookieInformationService, ZipCodeCookieInformationService } from '@inter-ikea-kompis/services';
export const setCookieStoreId = async (serviceSettings, storeId) => {
    const storeService = new StoreIdCookieInformationService({ settings: serviceSettings });
    storeId ? await storeService.setStoreId(storeId) : await storeService.clearStoreId();
};
export const setCookieZipCode = async (serviceSettings, zipCode) => {
    const zipService = new ZipCodeCookieInformationService({ settings: serviceSettings });
    await zipService.setZipCode(zipCode);
};
export const clearCookieZipCode = async (serviceSettings) => {
    const zipService = new ZipCodeCookieInformationService({ settings: serviceSettings });
    await zipService.clearZipCode();
};
//# sourceMappingURL=cookieInformation.js.map